import "core-js/modules/es.array.concat.js";
import i18n from 'i18n';
export default function getHelixGraphTooltip(value, label) {
  return value !== null ? "".concat(label, ": ").concat(value, "%") : "".concat(label, ": ").concat(i18n.t('skills_no_score'));
}